import {FuelStationColumns} from './model/fuel-station.columns';
import {FuelStationTableColumn} from './model/fuel-station-table-column';

export class FuelStationTableUtils {

  public static tableCols: FuelStationTableColumn[] = [
    {idx: 0, name: 'active', type: 'boolean', size: 60, filtering: false},
    {idx: 10, name: 'name', type: 'string', size: 160, filtering: false},
    {idx: 20, name: 'country', type: 'country', size: 100, filtering: false},
    {idx: 30, name: 'coordinates', type: 'string', size: 140, filtering: false},
    {idx: 40, name: 'contactless', type: 'boolean', size: 70, filtering: false},
    {idx: 50, name: 'priceGroup', type: 'priceGroup', size: 110, filtering: false},
    {idx: 60, name: 'price', type: 'number', size: 70, filtering: false},
    {idx: 70, name: 'discount', type: 'number', size: 70, filtering: false},
    {idx: 80, name: 'vat', type: 'number', size: 60, filtering: false},
    {idx: 90, name: 'exciseRefund', type: 'number', size: 90, filtering: false},
    {idx: 100, name: 'finalPrice', type: 'number', size: 80, filtering: false},
    {idx: 110, name: 'adbluePrice', type: 'number', size: 80, filtering: false},
    {idx: 120, name: 'lngPrice', type: 'number', size: 70, filtering: false},
    {idx: 130, name: 'hvoPrice', type: 'number', size: 70, filtering: false},
    {idx: 140, name: 'cngPrice', type: 'number', size: 70, filtering: false},
    {idx: 150, name: 'biodieselPrice', type: 'number', size: 90, filtering: false},
    {idx: 160, name: 'bevPrice', type: 'number', size: 90, filtering: false},
    {idx: 170, name: 'hydrogenPrice', type: 'number', size: 90, filtering: false},
    {idx: 180, name: 'currency', type: 'string', size: 70, filtering: false},
    {idx: 190, name: 'priceDate', type: 'date', size: 120, filtering: false},
    {idx: 200, name: 'comment', type: 'string', size: 150, filtering: false},
  ];

  public static defaultTableCols: FuelStationColumns[] = [
    {name: 'active', size: 60, filtering: false},
    {name: 'name', size: 160, filtering: false},
    {name: 'country', size: 100, filtering: false},
    {name: 'coordinates', size: 140, filtering: false},
    {name: 'contactless', size: 70, filtering: false},
    {name: 'priceGroup', size: 110, filtering: false},
    {name: 'price', size: 70, filtering: false},
    {name: 'discount', size: 70, filtering: false},
    {name: 'vat', size: 60, filtering: false},
    {name: 'exciseRefund', size: 90, filtering: false},
    {name: 'finalPrice', size: 80, filtering: false},
    {name: 'adbluePrice', size: 80, filtering: false},
    {name: 'currency', size: 70, filtering: false},
    {name: 'priceDate', size: 120, filtering: false},
    {name: 'comment', size: 150, filtering: false},
  ];
}
